import { CONFIG, type EnergyAction } from '../data/config';

export function actionCost(action: EnergyAction): number {
  return CONFIG.energyCosts[action];
}

export function canAfford(energy: number, action: EnergyAction): boolean {
  return energy >= CONFIG.energyCosts[action];
}

/** Spend energy for an action if affordable. `multiplier` lets a season cost more (winter). Pure. */
export function spendEnergy(
  energy: number,
  action: EnergyAction,
  multiplier = 1,
): { energy: number; ok: boolean } {
  const cost = Math.ceil(CONFIG.energyCosts[action] * multiplier);
  if (energy < cost) return { energy, ok: false };
  return { energy: Math.max(0, energy - cost), ok: true };
}

export function restoreEnergyFull(max: number = CONFIG.energyMax): number {
  return max;
}

/** A forced 2am collapse restores less than a chosen, timely sleep. Pure. */
export function restoreEnergyFromSleep(forced: boolean, max: number = CONFIG.energyMax): number {
  return forced ? Math.floor(max * 0.6) : max;
}
